import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "28e27e4b-6863-490f-a5fc-eaae440ac5a2",
  title: "Hansons Advanced Marathon",
  raceType: "Marathon",
  units: "miles",
  workouts: [
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description:
        "1.5 miles Warm Up\n12x400m @ 5k-10k Pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 9,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description:
        "1.5 miles Warm Up\n8x600m @ 5k-10k Pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n6 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 8,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description:
        "1.5 miles Warm Up\n6x800m @ 5k-10k Pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n6 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 8,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description:
        "1.5 miles Warm Up\n5x1km @ 5k-10k Pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n6 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 8,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "12 miles Long Run",
      totalDistance: 12,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description:
        "1.5 miles Warm Up\n4x1,200m @ 5k-10k Pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n7 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 9,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "10 miles Easy",
      totalDistance: 10,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description:
        "1.5 miles Warm Up\n3x1 miles @ 5k-10k Pace w. 800m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n7 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 9,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "4 miles Long Run",
      totalDistance: 14,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description:
        "1.5 miles Warm Up\n4x1,200m @ 5k-10k Pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n7 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 9,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "10 miles Easy",
      totalDistance: 10,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description:
        "1.5 miles Warm Up\n5x1km @ 5k-10k Pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n8 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 10,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "15 miles Long Run",
      totalDistance: 15,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description:
        "1.5 miles Warm Up\n6x800m @ 5k-10k Pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n8 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 10,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "10 miles Easy",
      totalDistance: 10,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description:
        "1.5 miles Warm Up\n6x1 miles @ MP - 10s w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 10.5,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n8 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 10,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "16 miles Long Run",
      totalDistance: 16,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description:
        "1.5 miles Warm Up\n4x1.5 miles @ MP - 10s w. 800m jog rest\n1.5 miles Cool Down",
      totalDistance: 11,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n9 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 11,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "10 miles Easy",
      totalDistance: 10,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description:
        "1.5 miles Warm Up\n3x2 miles @ MP - 10s w. 800m jog rest\n1.5 miles Cool Down",
      totalDistance: 10.5,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n9 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 11,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "6 miles Long Run",
      totalDistance: 16,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description:
        "1.5 miles Warm Up\n2x3 miles @ MP - 10s w. 1 miles jog rest\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n9 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 11,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "10 miles Easy",
      totalDistance: 10,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description:
        "1.5 miles Warm Up\n3x2 miles @ MP - 10s w. 800m jog rest\n1.5 miles Cool Down",
      totalDistance: 10.5,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n10 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 12,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "6 miles Long Run",
      totalDistance: 16,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description:
        "1.5 miles Warm Up\n4x1.5 miles @ MP - 10s w. 800m jog rest\n1.5 miles Cool Down",
      totalDistance: 11,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n10 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 12,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "10 miles Easy",
      totalDistance: 10,
    },
    {
      description: "#10 Long Run",
      totalDistance: 10,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description:
        "1.5 miles Warm Up\n6x1 miles @ MP - 10s w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 10.5,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n10 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 12,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "3 miles Easy",
      totalDistance: 3,
    },
    { description: "Race Day!", totalDistance: 26.2 },
  ],
} as BuiltInPlan;